import {
  Card,
  CardContent,
  CardHeader,
} from '@cambridgeassessment/cambridge-ui';
import { CardActionArea } from '@cambridgeassessment/cambridge-ui/build/components/Card';
import { Box, Container, Grid, Typography } from '@material-ui/core';
import React from 'react';
import { contactUs } from './constants';
import { useContactUsStyles } from './styles';

const ContactUsPage: React.FC = () => {
  const classes = useContactUsStyles();

  return (
    <Container disableGutters maxWidth="md">
      <Box mt={5} px={3}>
        <Typography variant="h2">Contact Us</Typography>
        <Box mt={2}>
          <Typography variant="body1">
            If you need support with your Cambridge account or any of the
            associated services, please contact one of our dedicated help teams
            below.
          </Typography>
        </Box>
      </Box>

      <Grid container className={classes.grindContainer}>
        {contactUs.externalLinks.map((link) => (
          <Grid
            key={link.title}
            item
            xs={12}
            sm={6}
            md={4}
            lg={4}
            xl={4}
            className={classes.cardGrid}
          >
            <Card className={classes.card} data-testid="link-card">
              <CardActionArea
                className={classes.fullHeight}
                href={link.url}
                target="_blank"
              >
                <CardContent className={classes.fullHeight}>
                  <CardHeader title={link.title} />
                  <Typography variant="body1">{link.description}</Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default ContactUsPage;
